import React from 'react'
import { CFooter } from '@coreui/react'
import HttpService from '../views/services/components/httpservices';
import { Env } from "../config";
// import { decryptor } from '../helpers/hasher.helper';
const header = {
  'Content-Type': 'application/json',
  'authorization': localStorage.getItem("token")
};
const TheFooter = () => {
  const [settingDetail, setSettingDetail] = React.useState();
  const getSettingDetails = async () => {
    await HttpService.get("setting_details", header).then((response) => {
      console.log(response.data.data)
      setSettingDetail(response.data.data);//decryptor(response.data.data)
    }).catch((error) => {
      console.log(error);
    });
  }
  React.useEffect(() => {
    getSettingDetails();
  }, []);
  const url = (Env === 'rmm') ? "http://rmmsolutions.in" : Env === 'emisafepro' ? "http://emisafepro.com/" : Env === 'safefin' ? "http://safefin.in/" : Env === 'rsecure' ? "http://retail-secure.in/" : "http://rmmsolutions.in";
  return (
    <CFooter fixed={false}>
      <div>
        <span className="ml-1">&copy; 2021 <a href={url} target="_blank" rel="noopener noreferrer">{settingDetail?.copyright.slice(7)}</a></span>
      </div>
    </CFooter>
  )
}

export default React.memo(TheFooter)
